import './css.js';

async function init() {
    await import('../../assets/unify/plugins/back-to-top.js');
    // await import('../../assets/unify/plugins/smoothScroll.js');
    await import('../../assets/unify/plugins/jquery.parallax.js');
    await import('../../assets/unify/plugins/owl-carousel/owl-carousel/owl.carousel.js');

    let App = await import('../../assets/unify/js/app.js');
    let OwlCarousel = await import('../../assets/unify/js/plugins/owl-carousel.js');
    jQuery(document).ready(function () {
        App.init();
        App.initParallaxBg();
        OwlCarousel.initOwlCarousel();
    });

    (function ($) {
        $('.type_accordion > li:eq(0) a').addClass('type_active').next().slideDown();
        $('.noact').closest('li').find('div').slideUp();

        $('.type_accordion > li > a').click(function (j) {
            var dropDown = $(this).closest('li').find('> div');
            if ($(this).hasClass('type_active')) {
                $(this).removeClass('type_active');
            } else {
                $(this).addClass('type_active');
            }

            dropDown.stop(false, true).slideToggle();

            j.preventDefault();
        });
    })(jQuery);
}

init();


// WEBPACK FOOTER //
// ./webpack/finish/entry.js